// @ts-nocheck
import React from "react";
import { Form, Button, Modal, Accordion } from "react-bootstrap";
import RichTextEditor from "../../../components/RichTextEditor";

export default function ComposeEmailModal({
  mailshow,
  setMailShow,
  setIsDisabled,
  validated,
  handleSubmit1,
  isDisabled,
  maildata,
  handleChanges1,
  defaultEditorContent,
  setMessage,
  CloseCompose,
  allCoupleData,
}: any) {
  return (
        <Modal
          size="lg"
          show={mailshow}
          onHide={() => {
            setMailShow(false);
            setIsDisabled(false);
          }}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit1}
            className="forms-sample"
          >
            <Modal.Header closeButton>
              <h3 className="page-title">Compose Email</h3>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group row">
                {/* {quickSearchFor ? (
                  <h6>
                    Quick Search Results ({dataCount > 0 ? dataCount : "0"}) -{" "}
                    {quickSearchFor}
                  </h6>
                ) : (
                  <label htmlFor="">
                    Search Results
                    {searchQuery ? (
                      <label>
                        {" "}
                        &nbsp; ({dataCount > 0 ? dataCount : "0"}){" "}
                      </label>
                    ) : null}{" "}
                    {searchQuery.searchFor ? (
                      <label>
                        {" "}
                        &nbsp;
                        {` - For ${
                          searchQuery.searchFor.charAt(0).toUpperCase() +
                          searchQuery.searchFor.slice(1)
                        }`}
                      </label>
                    ) : null}
                    {searchQuery && searchQuery.retreatId ? (
                      <label>
                        {" "}
                        &nbsp;
                        {` - ${
                          Array.isArray(searchQuery.retreatId) &&
                          searchQuery.retreatId.length > 0
                            ? `${selectRetreat
                                .filter((item) => item)
                                .map(
                                  (item) =>
                                    item.charAt(0).toUpperCase() + item.slice(1)
                                )
                                .join(", ")}`
                            : ""
                        }`}
                      </label>
                    ) : (
                      <label> &nbsp;{`- All Retreats `} &nbsp;</label>
                    )}
                    {searchQuery && searchQuery.coupleId ? (
                      <label>
                        {" "}
                        &nbsp;{" "}
                        {` - Couple - ${
                          Array.isArray(selectCouple) && selectCouple.length > 0
                            ? `${selectCouple
                                .filter((item) => item)
                                .map(
                                  (item) =>
                                    item.charAt(0).toUpperCase() + item.slice(1)
                                )
                                .join(", ")}`
                            : ""
                        } `}
                      </label>
                    ) : (
                      <label> &nbsp; {` - All Couples `}</label>
                    )}
                    {searchQuery && searchQuery.parisheId ? (
                      <label>
                        {" "}
                        &nbsp; -{" "}
                        {`${
                          selectParish
                            ? `${selectParish
                                .filter((item) => item)
                                .map(
                                  (item) =>
                                    item.charAt(0).toUpperCase() + item.slice(1)
                                )
                                .join(", ")}`
                            : ""
                        }`}
                      </label>
                    ) : null}
                    {searchQuery.dateFrom ? (
                      <label>
                        {" "}
                        - {moment(searchQuery.dateFrom).format(
                          "MMM DD yy"
                        )}{" "}
                      </label>
                    ) : null}{" "}
                    {searchQuery.dateTo ? (
                      <label>
                        {" "}
                        ,{moment(searchQuery.dateTo).format("MMM DD yy")}{" "}
                      </label>
                    ) : null}
                    {searchQuery.retreatants.length ? (
                      <label>
                        {" "}
                        &nbsp; -{searchQuery.retreatants.join(" , ")}
                      </label>
                    ) : null}
                    {serviceTextArray.length > 0 ? (
                      <label>
                        &nbsp;{` - Titles - ${serviceTextArray.join(" , ")}`}
                      </label>
                    ) : null}{" "}
                    {roleTextArray.length > 0 ? (
                      <label>
                        &nbsp;{` - Roles - ${roleTextArray.join(" , ")}`}
                      </label>
                    ) : null}{" "}
                    {talkTextArray.length > 0 ? (
                      <label>
                        &nbsp;{` - Talks - ${talkTextArray.join(" , ")}`}
                      </label>
                    ) : null}
                    {searchQuery.accountStatus.length > 0 ? (
                      <label>
                        {" "}
                        &nbsp;
                        {` - Status - ${searchQuery.accountStatus.join(" , ")}`}
                      </label>
                    ) : null}
                    {searchQuery.cityState.length > 0 ? (
                      <label>
                        &nbsp;
                        {` - City State - `}&nbsp;
                        {searchQuery.cityState
                          ? searchQuery.cityState.map((i, index, arr) => {
                              return (
                                <label>
                                  {i.label}{" "}
                                  {arr.length - 1 === i ? (
                                    <label>,</label>
                                  ) : null}{" "}
                                </label>
                              );
                            })
                          : null}
                      </label>
                    ) : null}
                    {searchQuery.primaryKey ? (
                      <label> - {searchQuery.primaryKey}</label>
                    ) : null}
                    {searchQuery.location.length > 0 ? (
                      <label>
                        &nbsp;
                        {` - Location - `}&nbsp;
                        {searchQuery.location
                          ? searchQuery.location.map((i, index, arr) => {
                              return (
                                <label>
                                  {i.label}{" "}
                                  {arr.length - 1 === i ? (
                                    <label>,</label>
                                  ) : null}{" "}
                                </label>
                              );
                            })
                          : null}
                      </label>
                    ) : null}
                    {searchQuery.language ? (
                      <label>
                        {" "}
                        -{" "}
                        {`              ${
                          Array.isArray(searchQuery.language) &&
                          searchQuery.language.length > 0
                            ? `${selectLanguage
                                .filter((item) => item)
                                .map(
                                  (item) =>
                                    item.charAt(0).toUpperCase() + item.slice(1)
                                )
                                .join(", ")}`
                            : ""
                        }`}{" "}
                      </label>
                    ) : null}
                    {searchQuery.neverServedTeam == true ? (
                      <label> &nbsp; - Never Served Team</label>
                    ) : null}
                    {searchQuery.neverTalk == true ? (
                      <label> &nbsp; - Never Talk</label>
                    ) : null}
                    {searchQuery.neverServiceRole == true ? (
                      <label> &nbsp; - Never Service Role</label>
                    ) : null}
                  </label>
                )} */}
                <label>To:</label>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Filtered Email</Accordion.Header>
                    <Accordion.Body>
                      {allCoupleData.length
                        ? allCoupleData.map((item, index) => (
                            <li>{item.label}</li>
                          ))
                        : " "}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <Form.Group className="form-group">
                <label htmlFor="exampleInputEmail1">Subject:</label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter Subject"
                  name="subject"
                  id="subject"
                  value={maildata.subject}
                  className="form-control"
                  onChange={(e) => handleChanges1(e)}
                  disabled={isDisabled}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter the Subject!
                </Form.Control.Feedback>
              </Form.Group>
              <div className="form-group sunEditor">
                <label htmlFor="exampleInputEmail1">Message:</label>
                <RichTextEditor
                  value={defaultEditorContent}
                  onChange={(e) => {
                    setMessage(e);
                  }}
                  readOnly={isDisabled}
                  variant="plain"
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={CloseCompose}>
                Close
              </Button>
              {isDisabled ? null : (
                <Button variant="primary" type="submit">
                  Send
                </Button>
              )}
            </Modal.Footer>
          </Form>
        </Modal>
  );
}